import styled from "styled-components";

export const Header = styled.header`
  display: flex;
  justify-content: flex-end;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;